import { useEffect, useMemo } from "react";
import { US_POST_JOIN_DOCUMENTS, type UsPostJoinDocumentFiles } from "../documents/us-document-types.ts";
import type { UsBankDetailsValues } from "../schemas/us-post-join.schema.ts";
import styles from "../../../../onboard-post-join/steps/review-step.module.css";

function FileLink({ file }: { file: File }) {
  const url = useMemo(() => URL.createObjectURL(file), [file]);
  useEffect(() => () => URL.revokeObjectURL(url), [url]);
  return <a href={url} target="_blank" rel="noopener noreferrer" className={styles.viewLink}>View</a>;
}

export function UsPostJoinReviewStep({ bank, cancelledCheque, documents }: { bank: UsBankDetailsValues; cancelledCheque: File | null; documents: UsPostJoinDocumentFiles }) {
  const bankFields: Array<[string, string]> = [
    ["Name on Bank Account", bank.beneficiaryName],
    ["Bank Name", bank.bankName],
    ["Bank Account Number", bank.accountNumber],
    ["Branch Name", bank.branchName || "—"],
    ["Bank Routing Number", bank.routingNumber],
  ];
  return <div className={styles.root}>
    <p className={`body-sm ${styles.lead}`}>Review your details before submission.</p>
    <hr className={styles.separator} />
    <section className={styles.section}><h3 className="heading-xs">Bank Details</h3><dl className={styles.dl}>{bankFields.map(([label, value]) => <div className={styles.dlItem} key={label}><dt>{label}</dt><dd>{value}</dd></div>)}<div className={styles.dlItem}><dt>Cancelled Cheque</dt><dd>{cancelledCheque ? <><FileLink file={cancelledCheque} /> <span className={styles.docName}>{cancelledCheque.name}</span></> : "—"}</dd></div></dl></section>
    <hr className={styles.separator} />
    <section className={styles.section}><h3 className="heading-xs">Documents</h3><ul className={styles.docList}>{US_POST_JOIN_DOCUMENTS.map((document) => { const file = documents[document.id]; return <li key={document.id} className={`body-sm ${styles.docRow}`}><span className={styles.docLabel}>{document.label}</span><div className={styles.docMeta}>{file ? <><FileLink file={file} /><span className={styles.docName}>{file.name}</span></> : <span className={styles.docNameMuted}>{document.required ? "—" : "Not uploaded"}</span>}</div></li>; })}</ul></section>
  </div>;
}

